import { AppState } from '../root-reducer';

export const selectMyProfile = (state: AppState) => state.accountDomain.myProfile;

export const selectLoggedIn = (state: AppState) => state.accountDomain.loggedIn;
